import AppService from "./../../../../modules/Appointments/service";

class DBBContractOptionsLoader {
  constructor() {
    if (DBBContractOptionsLoader._instance) {
      return DBBContractOptionsLoader._instance;
    }

    DBBContractOptionsLoader._instance = this;

    this.requests = {};
  }

  getContractOptions(dealerLocationId) {
    if (!this.requests[dealerLocationId]) {
      this.requests[dealerLocationId] = this.load(dealerLocationId).catch(error => {
        delete this.requests[dealerLocationId];
        throw error;
      });
    }

    return this.requests[dealerLocationId];
  }

  load(dealerLocationId) {
    const requestData = { dealer_location_id: dealerLocationId };

    return Promise.all([AppService.getDBBLeaseCompanies(requestData), AppService.getDBBStorageLocations(requestData)])
      .then(([leaseCompaniesResult, storageLocationsResult]) => {
        const leaseCompanies = leaseCompaniesResult?.data?.data?.lease_companies;
        const storageLocations = storageLocationsResult?.data?.data?.storage_locations;

        if (!Array.isArray(leaseCompanies) || !Array.isArray(storageLocations)) throw new Error("invalid response when loading DBB contract dropdowns options");

        return {
          leaseCompanyOptions: leaseCompanies.map(leaseCompany => ({ key: leaseCompany.id, value: leaseCompany.id, text: leaseCompany.name })),
          storageLocationOptions: storageLocations.map(storageLocation => ({
            key: storageLocation.id,
            value: storageLocation.id,
            text: storageLocation.name,
            description: storageLocation.sub_location_name,
          })),
        };
      })
      .catch(err => {
        if (err?.response?.data?.errors?.length) throw err.response.data.errors[0];

        throw err.message;
      });
  }
}

const DBBContractOptions = new DBBContractOptionsLoader();

export default DBBContractOptions;
